module.exports = __webpack_public_path__ + "static/media/hydration_success_icon.10010d5c.svg";